// tslint:disable
export enum Extauth2ForgotPasswordStatus {
    /**
     * @description forgot password was successful
     */
    Success = 0,
    /**
     * @description forgot password failed
     */
    Failed = 1,
    /**
     * @description forgot password invalid user
     */
    InvalidUser = 1,
    /**
     * @description forgot password account locked
     */
    AccountLocked = 1,
}
(Extauth2ForgotPasswordStatus as any)['SUCCESS'] = 0;
(Extauth2ForgotPasswordStatus as any)['FAILED'] = 1;
(Extauth2ForgotPasswordStatus as any)['INVALIDUSER'] = 1;
(Extauth2ForgotPasswordStatus as any)['ACCOUNTLOCKED'] = 1;
